

// // // src/components/ChatbotSidebar.js
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "../config";
import { FaEllipsisV, FaPlus } from "react-icons/fa";

function ChatbotSidebar({ setActiveChatbot }) {
  const [chatbots, setChatbots] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const email = localStorage.getItem("email");
    if (!email) return;

    fetch(`${API_BASE_URL}/chatbots?email=${email}`)
      .then((res) => {
        if (!res.ok) return [];
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data)) {
          setChatbots(data);
        } else {
          setChatbots([]);
        }
      })
      .catch((err) => {
        console.error(err);
        setChatbots([]);
      });
  }, []);

  /* Close dropdown on outside click */
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenMenuId(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const goToChat = (chatbot) => {
    setActiveChatbot?.(chatbot);
    navigate(`/chat/${chatbot.id}`);
  };

  const isActive = (id) => location.pathname === `/chat/${id}`;

  return (
    <aside className="w-64 bg-slate-950 border-r border-slate-800 flex flex-col h-full">

      {/* LOGO — aligned with chat header */}
      <div className="h-14 flex items-center px-6 border-b border-slate-800">
        <img
          src="https://storage.googleapis.com/rgw-public/logo-02.png"
          alt="Logo"
          className="h-8 object-contain"
        />
      </div>

      {/* SCROLLABLE CHATBOT LIST */}
      <div className="flex-1 overflow-y-auto px-2 py-3 space-y-1">
        <p className="px-3 text-[11px] uppercase text-slate-500 mb-2">
          Your Chatbots
        </p>

        {chatbots.map((bot) => (
          <div key={bot.id} className="relative">
            <button
              onClick={() => goToChat(bot)}
              className={`
              w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm
              ${isActive(bot.id)
                  ? "bg-emerald-500 text-slate-900 font-semibold"
                  : "text-slate-200 hover:bg-slate-800"}
            `}
            >
              <span className="truncate flex-1">
                {bot.chatbot_name || "Untitled Chatbot"}
              </span>

              <FaEllipsisV
                className="text-xs opacity-60 hover:opacity-100"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenMenuId(bot.id === openMenuId ? null : bot.id);
                }}
              />
            </button>

            {openMenuId === bot.id && (
              <div
                ref={dropdownRef}
                className="absolute right-3 mt-1 bg-slate-800 border border-slate-700
                         rounded-md shadow-lg z-50 text-xs"
              >
                <button
                  onClick={() => navigate(`/modify-chatbot/${bot.id}`)}
                  className="block px-3 py-2 hover:bg-slate-700 w-full text-left"
                >
                  Modify
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* FIXED BOTTOM CTA */}
      <div className="p-4 border-t border-slate-800 bg-slate-950">
        <button
          onClick={() => navigate("/create-chatbot")}
          className="
          w-full flex items-center justify-center gap-2
          rounded-xl py-3
          bg-indigo-600 hover:bg-indigo-500
          text-white font-semibold
          transition
        "
        >
          <FaPlus size={13} />
          Create Chatbot
        </button>
      </div>

    </aside>
  );


}

export default ChatbotSidebar;
